module.exports = __webpack_public_path__ + "img/hammer.svg";